module.exports = __webpack_public_path__ + "media/images/icons/icon-feature-drills-eb066daf21ed2e5678d90ff6eaf09bce.svg";